const buildTimestamp = WEBPACK_BUILD_TIMESTAMP;
const hashAsSecret = WEBPACK_HASH_AS_SECRET;

const siteWasOpenedTime = Date.now();
let lastRequestTime = Date.now();

async function sha256(input) {
  const msgUint8 = new TextEncoder().encode(input);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

function sortObjectByKey(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

export default (async function () {
  const isBrowserEnvironment = new Function("try {return this===window;}catch(e){ return false;}")()

  if (!isBrowserEnvironment || !buildTimestamp || !hashAsSecret) {
    throw new Error('Cant-create-signed-request-body')
  }

  let serverTs = 0;
  try {
    const abortController = new AbortController();
    setTimeout(() => abortController.abort(), 3000);
    const {msec} = await fetch('/msec', {signal: abortController.signal}).then((res) => res.json());

    serverTs = Math.floor(msec * 1000);
  } catch (err) {
    console.error(err);
  }

  let tsCorrection = serverTs ? Date.now() - serverTs : 0;
  if (Math.abs(tsCorrection) < 60 * 1000) {
    tsCorrection = 0;
  }

  return async (requestData) => {
    const ts = Date.now() - tsCorrection;
    lastRequestTime = Date.now();
    return {
      ...(typeof requestData === 'string' ? { url: requestData } : requestData),
      ts,
      _ts: buildTimestamp,
      _tsc: tsCorrection,
      _s: await sha256(`${
        typeof requestData === 'string'
        ? requestData
        : JSON.stringify(sortObjectByKey(requestData))
      }${ts}${hashAsSecret}`),
    };
  };
}());

// EXPERIMENTAL
// define a function to check if 24 hours have passed
function checkTime() {
  const elapsedOpenTime = Date.now() - siteWasOpenedTime;
  const elapsedRequestTime = Date.now() - lastRequestTime;
  const sinceWasOpenHours = Math.floor(elapsedOpenTime / (1000 * 60 * 60));
  const sinceLastRequestMin = Math.floor(elapsedRequestTime / (1000 * 60));

  if (sinceWasOpenHours >= 1 && sinceLastRequestMin >= 5) {
    location.reload();
  }
}

// call the checkTime function every hour
setInterval(checkTime, 1000 * 60 * 60); //
